import React from 'react'
import styled from 'styled-components'

import { InputLabel } from '../input/input'

type SearchInputProps = {
    value: string
    placeholder?: string
    onChange?: (query: string) => void
    onSearch: (query: string) => void
}

const SearchInput: React.FunctionComponent<SearchInputProps> = ({ value, placeholder, onChange, onSearch }) => (
    <InputLabel
        type="text" 
        value={value}
        placeholder={placeholder}
        onChange={ev => onChange && onChange!(ev.target.value)} 
        onKeyDown={ev => {
            if (ev.key !== 'Enter') {
                return
            }

            onSearch(value)
        }} 
    >
        <IconsContainer active={!!value}>
            <ClearIconContainer active={!!value}>
                <ClearIcon src={require('./images/clear.svg')} onClick={() => {
                    onChange && onChange!("")
                    onSearch("")
                }
                }/>
            </ClearIconContainer>
            <SearchIconContainer active={!!value}>
                <SearchIcon src={require('./images/search.svg')} onClick={() => onSearch(value)}/>
            </SearchIconContainer>
        </IconsContainer>
    </InputLabel>
)

const IconsContainer = styled.div<{active: boolean}>`
    position: absolute;
    right: 0;
    top: 0;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-items: start;

    height: 100%;
    aspect-ratio: ${p => p.active ? '2' : '1' } / 1;
`

const SearchIconContainer = styled.div<{active: boolean}>`
    display: grid;
    align-items: center;
    justify-items: center;

    height: 100%;
    aspect-ratio: 1 / 1;
    
    background: ${p => p.active ? p.theme.colors.accent : p.theme.colors.inactive };
    cursor: ${p => p.active ? 'pointer' : 'default' };
`

const SearchIcon = styled.img`
    width: 15px;
    height: 15px;
`


const ClearIconContainer = styled.div<{active: boolean}>`
    display: ${p => p.active ? 'grid' : 'none'};
    align-items: center;
    justify-items: center;

    height: 100%;
    aspect-ratio: 1 / 1;
    
    cursor: pointer;
`

const ClearIcon = styled.img`
    width: 20px;
    height: 20px;
`

export default SearchInput